export default "__VITE_ASSET__i2zrgRSI__"